import React, { useState, useEffect } from "react";
import { db } from "services/firebaseConfig";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { Button } from "components/ui/button";
import { Input } from "components/ui/input";
import { Label } from "components/ui/label";
import { toast } from "react-hot-toast";
import LoadingSpinner from "components/LoadingSpinner/LoadingSpinner";

function AdminSettingsManager() {
  const [dailyLimit, setDailyLimit] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const docRef = doc(db, "config", "excursions");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists() && typeof docSnap.data().dailyLimit !== "undefined") {
          setDailyLimit(docSnap.data().dailyLimit);
        } else {
          setDailyLimit(500); // Valor padrão inicial
        }
      } catch (err) {
        console.error("Erro ao buscar configurações:", err);
        toast.error("Erro ao carregar as configurações.");
      } finally {
        setIsLoading(false);
      }
    };
    fetchConfig();
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    try {
      const docRef = doc(db, "config", "excursions");
      await setDoc(docRef, { dailyLimit: Number(dailyLimit) }, { merge: true });
      toast.success("Configuração atualizada com sucesso!");
    } catch (err) {
      console.error("Erro ao salvar configuração:", err);
      toast.error("Erro ao salvar configuração.");
    } finally {
      setIsSaving(false);
    }
  };

  if (isLoading) return <LoadingSpinner />;

  return (
    <div className="bg-white p-6 rounded-lg border shadow-sm dark:bg-card max-w-2xl">
      <h2 className="text-lg font-semibold mb-2">Configurações Gerais</h2>
      <p className="text-sm text-muted-foreground mb-6">
        Ajuste os parâmetros de funcionamento do sistema.
      </p>

      <form onSubmit={handleSave} className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="dailyLimit">Limite Diário de Clientes (Excursões)</Label>
          <Input
            id="dailyLimit"
            type="number"
            min="1"
            value={dailyLimit}
            onChange={(e) => setDailyLimit(e.target.value)}
            className="w-48"
            required
          />
          <p className="text-xs text-muted-foreground">
            O sistema impedirá que usuários comuns (não-admins) abram o formulário de Adicionar Excursão se o total de clientes na data selecionada já tiver atingido este número.
          </p>
        </div>

        <Button type="submit" disabled={isSaving}>
          {isSaving ? "Salvando..." : "Salvar Configurações"}
        </Button>
      </form>
    </div>
  );
}

export default AdminSettingsManager;
